export const Bio = {
  name: "Trivedh Madala",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/madalatrivedh20/",
  resume:
    "https://drive.google.com/file/d/1XvZEjXhVj3n3-nDp4EPDCb6jxRK_fpZp/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/trivedh-madala/",
  email: "https://twitter.com/RishavChanda",
  insta: "https://www.instagram.com/3vedh_chandra",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Flask",
        image: "https://icon2.cleanpng.com/20180829/okc/kisspng-flask-python-web-framework-representational-state-flask-stickker-1713946755581.webp",
      },
      {
        name: "FastAPI",
        image: "https://www.softformance.com/wp-content/uploads/2022/07/1.3-FastAPI-Logo.jpg",
      },
      {
        name: "Spring Boot",
        image:
          "https://www.clipartmax.com/png/middle/117-1171017_spring-logo-spring-framework-logo.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Python",
        image:
          "https://banner2.cleanpng.com/20190623/yp/kisspng-python-computer-icons-programming-language-executa-1713885634631.webp",
      },
      {
        name: "C",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS25oYJlp2wL_GAT2FOKBaOlCt1fbn56-hXDg&s",
      },
      {
        name: "Javascript",
        image:
          "https://static.vecteezy.com/system/resources/previews/027/127/463/original/javascript-logo-javascript-icon-transparent-free-png.png",
      },
    ],
  },
  {
    title: "OS & Tools",
    skills: [
      {
        name: "Git",
        image:
          "https://banner2.cleanpng.com/20180425/bxe/ave8vhl4c.webp",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Linux",
        image:
          "https://w7.pngwing.com/pngs/1013/132/png-transparent-linux-distribution-tux-free-software-linux-kernel-linux-logo-bird-linux-thumbnail.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://w7.pngwing.com/pngs/17/131/png-transparent-postman-logo-thumbnail-tech-companies-thumbnail.png",
      },
      {
        name: "Windows",
        image:
          "https://w7.pngwing.com/pngs/899/626/png-transparent-windows-logo-windows-7-microsoft-logo-windows-8-microsoft-angle-window-green.png",
      },
      {
        name: "Canva",
        image:
          "https://w7.pngwing.com/pngs/714/984/png-transparent-canva-design-soft-design-tool-design-tool-logo-design-logo-tool-3d-icon-thumbnail.png",
      },
      {
        name: "Jira",
        image:
          "https://w7.pngwing.com/pngs/992/738/png-transparent-jira-hd-logo-thumbnail.png",
      },
      {
        name: "Confluence",
        image:
          "https://cdn-icons-png.flaticon.com/512/5968/5968793.png",
      },
      
    ],
  },
  
  {
    title: "Concepts",
    skills: [
      {
        name: "Networking Protocols",
        image:
          "https://static.vecteezy.com/system/resources/thumbnails/008/681/148/small/computer-network-internet-technologies-icon-vector.jpg",
      },
      {
        name: "Object Oriented Design",
        image:
          "https://w7.pngwing.com/pngs/605/851/png-transparent-java-programming-computer-programming-programming-language-object-oriented-programming-burn-miscellaneous-class-logo-thumbnail.png",
      },
      {
        name: "SDLC-Agile Methodologies",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQofvCe0j_xB9236C6_HjbRE8Tjjrcg1YQnUA&s",
      },
      {
        name: "Machine Learning",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/d/d5/Hey_Machine_Learning_Logo.png",
      },
      {
        name: "NLP",
        image:
          "https://thumbs.dreamstime.com/b/nlp-letter-technology-logo-design-white-background-creative-initials-concept-253007998.jpg",
      },
      {
        name: "IOT",
        image:
          "https://static.vecteezy.com/system/resources/previews/028/119/231/non_2x/internet-of-things-icon-free-vector.jpg",
      },
      {
        name: "Test Automation",
        image:
          "https://w7.pngwing.com/pngs/821/451/png-transparent-software-testing-computer-icons-computer-software-openframeworks.png",
      },
      {
        name: "Software Architecture",
        image:
          "https://t3.ftcdn.net/jpg/05/06/52/84/360_F_506528493_P1NP532YG3kEDuBgcPv9paDAfoVoJfpi.jpg",
      },
      {
        name: "Design Principles",
        image:
          "https://cdn-icons-png.flaticon.com/512/5968/5968793.png",
      },
      
    ],
  },

  {
    title: "Certifications & Research Papers",
    skills: [
      {
        name: "Infosys Certified Software Programmer",
        image:
          "https://banner2.cleanpng.com/20180425/bxe/ave8vhl4c.webp",
      },
      {
        name: "Microsoft Certified: Azure Fundamentals",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "NPTEL Joy of Computing with Python",
        image:
          "https://w7.pngwing.com/pngs/1013/132/png-transparent-linux-distribution-tux-free-software-linux-kernel-linux-logo-bird-linux-thumbnail.png",
      },
      {
        name: "Suspicious Activity Detection and Tracking through Unmanned Aerial Vehicle Using Deep Learning Techniques",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNq2gIzdOtoxsPDHsZJ-i2UsJuNfmsVywM9Q&s",
      },
      {
        name: "Health Monitoring of Critical Care Patients using Internet of Things",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTK5yYwiboSUBOOnycMjMYKIgC5FFUOwrREbg&s",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Wells_Fargo_Logo_%282020%29.png/800px-Wells_Fargo_Logo_%282020%29.png",
    role: "Software Engineer",
    company: "Wells Fargo International Solutions",
    date: "Aug 2023 - Present",
    desc: "Developed a user-centric feature using React, SpringBoot and SQL, enabling bankers to create personalized dashboards and achieve aremarkable 90% improvement in productivity and efficiency. Collaborated with cross-functional teams to develop and deploy the modern version of the existing full stack application, that drove continuous improvement and elevated bankers experience",
    skills: [
      "JavaScript",
      "React Js",
      "Spring Boot",
      "SQL",
      "Node Js",
      "Jest",
      "React Testing Library (RTL)",
      "Redux",
      "GraphQL"
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Wells_Fargo_Logo_%282020%29.png/800px-Wells_Fargo_Logo_%282020%29.png",
    role: "Program Associate",
    company: "Wells Fargo International Solutions",
    date: "August 2022 - August 2023",
    desc: "Developed a due diligence full stack web application using React Js and Python (Flask), which facilitates bankers to make informed decisions on loan applications, enhancing efficiency and accuracy in the approval process.Developed and implemented a conversational chatbot POC to streamline employee access to company resources, including benefits information, facilitating efficient information retrieval within the organization.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "Flask",
      "SQL",
      "JavaScript",
    ],
    doc: "",
  },
  {
    id: 2,
    img: "https://www.citypng.com/public/uploads/preview/cisco-square-blue-logo-icon-png-735811696612218gzoiadfplh.png",
    role: "Technical Undergraduate Intern",
    company: "Cisco Systems",
    date: "Jan 2022 - June 2022",
    desc: "Creation of a Drag and Drop user interface using React Js for a Smart Chatbot creation application powered by Mindmeld, enhancing the user experience, better creation and debugging of dialog flow management.Developed the GUI from scratch using React Js and improved the response time for the user’s request, implemented Restful APIs to enhance communication with external applications, resulting in a remarkable increase of 90% in efficiency and accuracy",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
      "FastAPI",
      "Flask",
      "MongoDB",
    ],
    doc:'https://drive.google.com/file/d/1G0gIm6mHQTr36WJZBLyUZJE_sEIidhE7/view?usp=sharing'
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8m3OKSy7bzRlTL1RQNQqFa2rKloHyZy3z3w&s",
    role: "Artificial Intelligence Intern",
    company: "DevIncept",
    date: "Oct 2020 - Nov 2020",
    desc: "Developed a cutting-edge Next Word Predictor application utilizing LSTM technology for enhanced text prediction capabilities.Engineered a live sketch application leveraging webcam functionality to create real-time digital art experiences",
    doc: "https://drive.google.com/file/d/1SqCyLuIIlONy8BUdgIDC72X_rygdmOH6/view?usp=sharing",
    skills: ["Flask","FastAPI","NLP","Machine Learning"]
    },
    {
      id: 4,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8m3OKSy7bzRlTL1RQNQqFa2rKloHyZy3z3w&s",
      role: "Open source Contributor",
      company: "DevIncept",
      date: "Sept 2020 - Oct 2020",
      desc: "Designed and developed curriculum and tutorials on various technical concepts, including Python, Flask, FastAPI, and machine learning algorithms, tailored for upcoming students. Collaborated with cross-functional teams to create and refine content on data science fundamentals, ensuring high-quality learning materials. Contributed to open-source projects, enhancing educational resources for the developer community.",
      doc: "https://drive.google.com/file/d/1USAECCpJaZbYDPbK0mFF3osQ_-wdSO7X/view?usp=sharing",
      skills: ["Flask","FastAPI","Git","Data Science"]
      },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNheQM7rsjAI9PvCabTdRlLcMjO5LyORNMEA&s",
    school: "Gokaraju Rangaraju Institute of Engineering and Technology",
    date: "Jun 2018 - June 2022",
    grade: "9.16 CGPA",
    desc: "I have pursued my Bachelor's degree in Information Technology at Gokaraju Rangaraju Institute of Engineering and Technology, Hyderabad. I have graduated with a CGPA of 9.16. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a core committe member of various Student bodies like IEEE, IETE, ISTE, CSI at GRIET , where I have worked on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Information Technology",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqRx43-vajk9Kd1JWmwS_6wf18q-vb02l5RA&s",
    school: "Sri Chaitanya Junior College",
    date: "Apr 2016 - Apr 2018",
    grade: "95.7%",
    desc: "I completed my class 12 high school education at Sri chaitanya Junior kalasala, Hyderabad, where I studied MPC (Maths, Physics, Chemistry).",
    degree: "(XII), MPC",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQiCM7mrsT60hYardynVvcZrfGF4WBeqEh6w&s",
    school: "Little Flower School",
    date: "Apr 2015 - Apr 2016",
    grade: "9.8 CGPA",
    desc: "I completed my class 10 education at Little Flower School, Hyderabad.",
    degree: "CBSE(X)",
  },
];

export const projects = [
  {
    id: 9,
    title: "NLP Personal assistant for visually challenged people",
    date: "",
    description:"Created a voice-controlled mailing system application to facilitate visually impaired users in managing their emails through intuitive voice commands.",
    image:
      "https://cdn.mos.cms.futurecdn.net/zssPWzcsMcFSQEt6uMAjDT.png",
    tags: [
      "React Js",
      "NLP",
      "Python",
      "SMTP",
      "Redux",
    ],
    category: "web app and ml",
    github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://trackify.duckdns.org",
  },
  {
    id: 0,
    title: "Interactive E-Learning System",
    date: "",
    description:
      "Developed an interactive e-learning platform with React.js and FastAPI, featuring user authentication, course management, and quiz functionality.",
    image:
      "https://elearningindustry.com/wp-content/uploads/2020/11/how-to-use-animation-for-online-courses.jpg",
    tags: ["React Js", "MongoDb", "Node Js", "Flask", "Redux", "Material UI", "Firebase"],
    category: "web app",
    github: "https://github.com/rishavchanda/Podstream",
    webapp: "https://podstream.netlify.app/",
  },
  {
    id: 1,
    title: "Resume Best Match (Application Tracking System) ",
    date: "",
    description:
      "Developed a Resume Best Match tool, utilizing advanced algorithms to streamline resume screening for efficient candidate selection. ",
    image:
      "https://www.techfunnel.com/wp-content/uploads/2020/09/top_applicant_tracking_systems.png",
    tags: [
      "React Js",
      "MongoDb",
      "FastAPI",
      "LangChain",
      "Redux",
      "Machine Learning",
    ],
    category: "web app and ml",
    github: "https://github.com/rishavchanda/Project-Management-App",
    webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Autonomous and IOT based Irrigation system",
    date: "",
    description:
      "A project developed to provide a common platform for both autonomous and manual operation of Irrigation system. It is developed using Aurdino. It can be operated autonomously using soil moisture sensor or using the mobile web page.",
    image:
      "https://i.imgur.com/LSbwe5E.jpg",
    tags: ["ThingSpeak", "IOT", "HTML", "CSS","Javascript"],
    category: "web app and iot",
    github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    webapp: "https://brain-tumor.netlify.app/",
  },
  {
    id: 3,
    title: "Fuel Anti-theft or leakage detection using IOT",
    date: "",
    description:
      "Engineered an autonomous application to promptly alert users in the event of fuel theft or leakage from their vehicle, ensuring timely intervention and safeguarding against potential hazards or losses.",
    image:
      "https://www.iconcox.com/wp-content/uploads/2022/12/Remote-Fuel-Monitoring-Solution.jpg",
    tags: ["HTML", "CSS", "IOT","Firebase","ThingSpeak"],
    category: "web app and iot",
    github: "https://github.com/rishavchanda/Buckoid-Android-App",
    webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 10,
    title: "Vehicle Number Plate Recognition",
    date: "",
    description:
      "It is an application developed to detect the number plates of the vehicles, which are involved in the cases like rash driving, hit and run cases or in the toll-gates.",
    image:
      "https://www.shaip.com/wp-content/uploads/2022/08/Blog_Automatic-Number-Plate-Recognition-ANPR.jpg",
    tags: ["HTML", "CSS", "Python", "Open CV", "Machine Learning"],
    category: "web app and ml",
    github: "https://github.com/rishavchanda/Job-finder-App",
    webapp: "https://github.com/rishavchanda/Job-finder-App",
  },
  {
    id: 4,
    title: "Critical Care Patient Monitoring using IOT",
    date: "",
    description:
      "It is a smart system that sends out an alert to the patient’s family members or hospitals in case of an emergency using a GSM module. This proposed project consists of various sensors like Temperature sensor, Pulse sensor, Eye blink sensor for collecting the patient’s body temperature, heart rate, eye movement of the patient. Apart from these a motion detector sensor is also integrated with the system, which detects the motion of the patient under monitor. This system uses an ESP32 as the microcontroller. The patient’s health is constantly monitored through this system which facilitates immediate precautionary measures in case of serious conditions.",
    image:
      "https://media.licdn.com/dms/image/D4E12AQFGtFcmqhlrhA/article-cover_image-shrink_720_1280/0/1708518754873?e=2147483647&v=beta&t=6ceGFot9-JTjgnJT_b8sCYQ0TFnqKoxN4JFo7zO-7MM",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app and iot",
    github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    webapp: "https://whatsapp-clone-rishav.web.app",
  },
  {
    id: 5,
    title: "Todo Web App",
    date: "Jun 2021",
    description:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://img.freepik.com/premium-vector/list_1133-600.jpg",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Todo-Web-App",
    webapp: "https://rishav-react-todo.netlify.app/",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
